import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "../src/style/css/iconsax.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/@tabler/icons-webfont/dist/tabler-icons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.scss";

import { Provider, useDispatch } from "react-redux";
import store from "./core/redux/store";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import ALLRoutes from "./feature-module/router/router";

import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { setUser, clearUser } from "./core/redux/authSlice";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const AuthListener: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Serialize to a plain object — Redux cannot store class instances like UserImpl
        dispatch(setUser({
          uid:           user.uid,
          email:         user.email,
          displayName:   user.displayName,
          photoURL:      user.photoURL,
          emailVerified: user.emailVerified,
          phoneNumber:   user.phoneNumber,
        }));
      } else {
        dispatch(clearUser());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return <ALLRoutes />;
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename={base_path}>
      <AuthListener />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
